/* ==========================================================================
   MUGUKLIMA — bymugu.js
   Click burst only. No custom cursor, no theme switching.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var FLAKE = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
    '<g stroke="currentColor" stroke-width="1.2" stroke-linecap="round">' +
    '<line x1="10" y1="2" x2="10" y2="18"/><line x1="3" y1="6" x2="17" y2="14"/>' +
    '<line x1="3" y1="14" x2="17" y2="6"/><line x1="10" y1="5" x2="8.2" y2="3.2"/>' +
    '<line x1="10" y1="5" x2="11.8" y2="3.2"/><line x1="10" y1="15" x2="8.2" y2="16.8"/>' +
    '<line x1="10" y1="15" x2="11.8" y2="16.8"/></g>' +
    '<circle cx="10" cy="10" r="1.2" fill="currentColor"/></svg>';

  var live = 0;
  var MAX_PARTICLES = 36;

  function flake(x, y, size, life, dx, dy) {
    if (live >= MAX_PARTICLES) return;
    live++;
    var el = document.createElement('div');
    el.className = 'burst-flake';
    el.style.left = (x - size / 2) + 'px';
    el.style.top = (y - size / 2) + 'px';
    el.style.width = size + 'px';
    el.style.height = size + 'px';
    el.style.setProperty('--dx', dx + 'px');
    el.style.setProperty('--dy', dy + 'px');
    el.innerHTML = FLAKE;
    document.body.appendChild(el);
    window.setTimeout(function () { el.remove(); live--; }, life);
  }

  function burst(x, y, count) {
    if (reduceMotion.matches) return;
    for (var i = 0; i < count; i++) {
      var angle = (i / count) * Math.PI * 2 + Math.random() * 0.4;
      var dist = 60 + Math.random() * 55;
      flake(x, y, 10 + Math.random() * 9, 1300, Math.cos(angle) * dist, Math.sin(angle) * dist + 20);
    }
    var ring = document.createElement('div');
    ring.className = 'click-ring';
    ring.style.left = (x - 20) + 'px';
    ring.style.top = (y - 20) + 'px';
    document.body.appendChild(ring);
    window.setTimeout(function () { ring.remove(); }, 700);
  }

  document.addEventListener('click', function (e) {
    // real mouse clicks only — keyboard activation reports 0/0
    if (!e.clientX && !e.clientY) return;
    // nothing over form fields, the cart drawer or checkout
    if (e.target.closest && e.target.closest('input, select, textarea, .cart-drawer, [name="checkout"]')) return;
    burst(e.clientX, e.clientY, 10);
  }, { passive: true });
})();